import { render, staticRenderFns } from "./MyCountWebpart.vue?vue&type=template&id=8d8d5404&scoped=true"
import script from "./MyCountWebpart.ts?vue&type=script&lang=ts&external"
export * from "./MyCountWebpart.ts?vue&type=script&lang=ts&external"
import style0 from "./MyCountWebpart.vue?vue&type=style&index=0&id=8d8d5404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8d5404",
  null
  
)

export default component.exports